export const PricingData = [
    {
        id: 1,
        price: 'Free Trial',
        subtitle: 'Limited Free Trial plan for all users',
        features: [
            {
                title: 'Access anytime',
                positive: true
            },
            {
                title: 'All supported platforms',
                positive: true
            },
            {
                title: '15 Requests per day',
                positive: true
            },
        ]
    },
    {
        id: 2,
        price: '$4/mo',
        subtitle: 'Premium plan to prepare for interviews',
        features: [
            {
                title: 'Access anytime',
                positive: true
            },
            {
                title: 'All supported platforms',
                positive: true
            },
            {
                title: '100 Requests per day',
                positive: true
            },
            {
                title: 'Interviewer Mode',
                positive: true
            },
            {
                title: 'Newer Models',
                positive: true
            },
        ]
    },
]